export const Story = () => {
  return (
    <section
      id="story"
      data-testid="story-section"
      className="relative py-28 md:py-40 bg-[#1A362D] text-[#FDFBF7] overflow-hidden"
    >
      <div className="absolute inset-0 ah-grain opacity-[0.08] pointer-events-none" />
      <div className="absolute -top-32 left-1/2 -translate-x-1/2 w-[600px] h-[600px] rounded-full border border-[#C29B62]/15 pointer-events-none" />
      <div className="absolute -top-20 left-1/2 -translate-x-1/2 w-[400px] h-[400px] rounded-full border border-[#C29B62]/10 pointer-events-none" />

      <div className="relative max-w-3xl mx-auto px-6 md:px-12 text-center">
        <div className="flex items-center justify-center gap-3 mb-8">
          <span className="h-px w-10 bg-[#C29B62]" />
          <span className="text-xs uppercase tracking-[0.3em] font-semibold text-[#C29B62]">
            The Activehuman Difference
          </span>
          <span className="h-px w-10 bg-[#C29B62]" />
        </div>

        <h2 className="font-serif-display text-4xl md:text-5xl lg:text-[64px] leading-[1.05] tracking-tight font-medium">
          Evidence-based nutrition. <em className="italic text-[#C29B62] font-normal">No gimmicks.</em>
        </h2>

        <p className="mt-10 text-lg md:text-xl text-[#FDFBF7]/80 font-light leading-[1.7]">
          At Activehuman, we believe in addressing the foundations of health through evidence-based nutrition and
          high-quality ingredients. No gimmicky supplement which is not proven.
        </p>

        <p className="mt-6 text-base md:text-lg text-[#FDFBF7]/70 font-light leading-[1.7]">
          Our products are developed with a focus on bioavailability, quality, and simplicity — helping people build
          better health, one habit at a time.
        </p>

        <div className="mt-14 grid grid-cols-3 max-w-2xl mx-auto gap-6 text-left">
          {[
            { k: "Bioavailability", v: "Formulations designed to be absorbed and used by the body." },
            { k: "Quality", v: "High-grade ingredients, tested standards." },
            { k: "Simplicity", v: "Clean labels. No unnecessary additions." },
          ].map((p, i) => (
            <div key={p.k} data-testid={`principle-${i + 1}`} className="border-t border-[#C29B62]/40 pt-4">
              <div className="font-serif-display text-xl md:text-2xl text-[#C29B62] mb-2">{p.k}</div>
              <div className="text-xs md:text-sm text-[#FDFBF7]/70 font-light leading-relaxed">{p.v}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
